import "./button.component.style.scss";
import { FC, useState } from "react";
import ButtonComponentProps from "./button.component.props";

const ButtonComponent: FC<ButtonComponentProps> = ({ onClick, text, className, design = "primary", disabled, height, icon, isLoading, style, type = "button", width }) => {
    const [callingFunction, setCallingFunction] = useState(false);
    const _handleClick = async (event: React.MouseEvent) => {
        setCallingFunction(true);
        await onClick?.(event);
        setCallingFunction(false);
    }
    const loading = isLoading || callingFunction;
    return (
        <button className={`button_component ${design} btn ${className}`} style={{
            ...style,
            height,
            width,
        }}
            type={type}
            disabled={loading || disabled} onClick={_handleClick}>{
                (icon || loading) && <div className="icon" style={(text?.length ?? 0) <= 0 ? { margin: 0 } : {}}>{!loading ? icon
                    : <div className="spinner-border spinner-border-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                }</div>
            } {text}</button>
    );
}

export default ButtonComponent;